import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import ContentLoader from "react-content-loader"
import Avatar from '../../../components/Avatar';
import DateSince from '../../../components/Date';
import {config} from "../../../../config";
import createLink from "../../../../libs/createLink";

const MeetArround = (props) => {
    let title = props.title || "";
    if (title.length > 40) {
        title = title.substring(0, 40) + '...';
    }
    let hasOwner = props.owner !== null && props.owner._id;
    return (
        <div className={`meet-arround ${hasOwner ? config.genderClass[props.owner.profile.gender] : ""}`}>
            {props.datingTopicsInitialized && props.datingTopicsLoading ? (
                <ContentLoader
                    height={180}
                    width={350}
                    speed={2}
                    ariaLabel={false}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="72.91" y="71.61" rx="4" ry="4" width="194.73" height="14.85"/>
                    <rect x="41.37" y="148.67" rx="3" ry="3" width="91.83" height="6.91"/>
                    <circle cx="21.59" cy="150.48" r="15.49"/>
                    <rect x="9.44" y="8.61" rx="0" ry="0" width="107" height="8"/>
                    <rect x="232.44" y="7.61" rx="0" ry="0" width="98" height="8"/>
                    <rect x="230.44" y="147.61" rx="0" ry="0" width="100" height="9"/>
                </ContentLoader>
            ) : (
                <Fragment>
                    <div className="topline row justify-space-between">
                        <span className="city">Région : <Link
                            to={createLink("forumCategory",props.forum.parent ? {categoryParent : {slug : props.forum.parent.slug}, category : {_id : props.forum._id, slug : props.forum.slug}} : {category : {_id : props.forum._id, slug : props.forum.slug}})}>{props.forum.name}</Link></span>
                        <span className="date">
                            <DateSince
                                date={props.createdAt}
                                prefix={false}
                                currentFormat={true}
                            />
                        </span>
                    </div>
                    <Link to={createLink("forumTopic", props.forum.parent ? {category : {slug : props.forum.slug, _id : props.forum._id}, topic : {_id : props._id, slug : props.slug}, categoryParent : {slug : props.forum.parent.slug}} : {category : {slug : props.forum.slug, _id : props.forum._id}, topic : {_id : props._id, slug : props.slug}}) } className="content">
                        {title}
                    </Link>
                    <div className="baseline">
                        <div className="last-participant">
                            <div className="avatar-wrapper">
                                {hasOwner ? (
                                    <Link to={createLink("userProfile", props.owner)}>
                                        <Avatar avatar={props.owner.profile.avatar} gender={props.owner.profile.gender} width={24} height={24} />
                                    </Link>
                                ) : (
                                    <Avatar gender={"guest"} />
                                )}
                            </div>
                            <span className="total-participant">{props.count.comment} reponses</span>
                        </div>
                        {/*<Link to={`${props.breadcrumb[2].link}`} className="forum-location">{props.breadcrumb[2].name}</Link>*/}
                    </div>
                </Fragment>
            )}
        </div>
    )
};

export default MeetArround;
